import MuiTable from "../common/MuiTable";
import {React, useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { UI_6_2_popup_tableRow_sink, UI_6_2_popup_tableRow_source } from "./UI_6_2_popup.helper";


export const UI_6_2_popup = (props) => {
  const { sinkSourceLabel, popupData, sourceSink } = props
  const [fetchData, setFetchData] = useState([]);
  // 매도 - source - sell
  // 매수 - sink - buy

  const dataGrid1 = (
    sellPlantInloName,
    calcYm,
    trnsVol,
    engUnit,
    unitPrice,
    trnsVolChrg,
  ) => {
    return {
      sellPlantInloName,
      calcYm,
      trnsVol,
      engUnit,
      unitPrice,
      trnsVolChrg,
    };
  };

  const dataGrid2 = (
    buyPlantInloName,
    calcYm,
    trnsVol,
    engUnit,
    unitPrice,
    trnsVolChrg,
  ) => {
    return {
      buyPlantInloName,
      calcYm,
      trnsVol,
      engUnit,
      unitPrice,
      trnsVolChrg,
    };
  };

  const resultData = fetchData.map(item => {
    if (sourceSink == "SINK") {
      return dataGrid1(
        item.sellPlantInloName,
        item.calcYm,
        item.trnsVol ? new Intl.NumberFormat("ko-KR").format(item.trnsVol) : '',
        item.engUnit,
        item.unitPrice,
        item.trnsVolChrg ? new Intl.NumberFormat("ko-KR").format(item.trnsVolChrg) : '',
      )
    } else {
      return dataGrid2(
        item.buyPlantInloName,
        item.calcYm,
        item.trnsVol ? new Intl.NumberFormat("ko-KR").format(item.trnsVol) : '',
        item.engUnit,
        item.unitPrice,
        item.trnsVolChrg ? new Intl.NumberFormat("ko-KR").format(item.trnsVolChrg) : '',
      )
    }
  })

  useEffect(() => {
    getPopupData();
  }, [props]);

  const getPopupData = async () => {

    const param = {
      sourceSink: sourceSink,
      plantInloNo: popupData.plantInloNo,
      energy: popupData.engId
    }

    try {
      const uri = "vup/select_6_2_popup";
      const res = await FxmsData.GET(uri, param);
      console.log("select_6_2 res.....", res.data);
      setFetchData(res.data);
    } catch (e) {
      console.log("UI_6_2_POPUP error.....", e);
    }
  }

  return (
    <>
    <div className="vupNewLayerPop">
      <div className="lpopTitle">
        <strong>{sinkSourceLabel}결산 상세</strong>
        <button onClick={props.closePopup} className="popClose">닫기</button>
      </div>
      <div className="predict">
        <div className="FxMuiTable mb20">
          <table>
            <tbody>
            <tr>
              <th>산업단지명</th>
              <td className="right">{popupData.complexInloName}</td>
              <th>{sourceSink==="SINK"?"매수공장" : "매도공장"}</th>
              <td className="right">{popupData.plantInloName}</td>
            </tr>
            <tr>
              <th>에너지종류</th>
              <td className="right">{popupData.engDescr}</td>
              <th>결산월</th>
              <td className="right">{popupData.calcYm}</td>
            </tr>
            <tr>
              <th>거래량</th>
              <td className="right">{popupData.hasOwnProperty("orgTrnsVol")? (popupData.orgTrnsVol).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","): ""}</td>
              <th>결산금액</th>
              <td className="right">{popupData.hasOwnProperty("orgCalcAmt")? (popupData.orgCalcAmt).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):"0"}원</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div className="FxMuiTable">
          <MuiTable
              tableRowDataList={sinkSourceLabel == "매수" ? UI_6_2_popup_tableRow_sink : UI_6_2_popup_tableRow_source}
              rows={resultData}
              menuFullName ={sinkSourceLabel+"결산상세"} 
          />
        </div>
      </div>

    </div>
    </>
  )
}